import { S3_BUCKET_URL } from '@/constants';

import { Outfit } from './screens/Outfit';
import { Photo } from './screens/Photo';
import { Video } from './screens/Video';
import { Welcome } from './screens/Welcome';

import type { LayoutDataType } from './types';

export const layoutSteps = {
  welcome: {
    component: Welcome,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-maxim/welcome/background.png`,
      `${S3_BUCKET_URL}/layout-own-ai-maxim/welcome/bubble.png`,
    ],
  },
  photo: {
    component: Photo,
    images: [`${S3_BUCKET_URL}/layout-own-ai-maxim/photo/photo.webm`],
  },
  video: {
    component: Video,
    images: [`${S3_BUCKET_URL}/layout-own-ai-maxim/video/video.webm`],
  },
  outfit: {
    component: Outfit,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-maxim/outfit/background.png`,
      `${S3_BUCKET_URL}/layout-own-ai-maxim/outfit/jacket.png`,
      `${S3_BUCKET_URL}/layout-own-ai-maxim/outfit/top-tank.png`,
    ],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export type LayoutStepKeyType = keyof typeof layoutSteps;

export const layoutDataDefault: LayoutDataType = {};
